import "./design/themes/cpp-monday.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import styled, { ThemeProvider } from "styled-components";

import WithMondayContextAvailable from "@/components/AppContext/WithMondayContextAvailable";
import MetricsPreloader from "@/components/DataPreloader/MetricsPreloader";
import { cppTheme } from "@/design/themes/Themes";

import AppRouter from "./AppRouter";
import { servicesConfig } from "./services/services-configs";

const { mondayService } = servicesConfig();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

const StyledApp = styled.div`
  height: 100%;
`;
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <StyledApp>
        <MetricsPreloader />
        <ThemeProvider theme={cppTheme}>
          <WithMondayContextAvailable mondayService={mondayService}>
            <AppRouter />
          </WithMondayContextAvailable>
        </ThemeProvider>
      </StyledApp>
    </QueryClientProvider>
  );
};

export default App;
